export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.triggerId = item != null ? item.triggerId : ''
        this.regex = item != null ? item.regex : '' 
    }
}